import React from "react";

function IDODevSer() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right pt-3">
                Unlocking Seamless Fundraising with Customized IDO Development
              </h2>
              <p className="pb-3">
                Xeer Technology specializes in full-scale IDO (Initial DEX
                Offering) development services, providing blockchain projects
                with the tools and support they need to successfully launch
                tokens and attract a global investor base. From smart contract
                development to security audits and marketing strategies, we
                deliver a streamlined, end-to-end IDO development experience
                tailored to your project’s goals.
              </p>

              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IDODevSer;
